import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { selectFilteredValues } from './selectors';
import s from '../index.css';

const propTypes = {
    onChange: PropTypes.func.isRequired,
    values: PropTypes.arrayOf(
        PropTypes.shape({
            reportParamValue: PropTypes.string,
            reportParamDesc: PropTypes.string,
        })
    ).isRequired,
    search: PropTypes.string.isRequired,
    selected: PropTypes.any,
};

const mapStateToProps = (state, ownProps) => ({
    data: selectFilteredValues(state, ownProps),
});

class RequestFormAutocompleteList extends React.PureComponent {
    render() {
        const { data } = this.props;

        if (data && data.entries && data.entries.length > 0) {
            return data.entries.map((entry, entryIndex) => (
                <button
                    key={entry.key}
                    onClick={this.handleClick(entryIndex)}
                    className={classNames(s.entry, { [s.active]: entry.isSelected })}
                >
                    {entry.name}
                </button>
            ));
        } else {
            return (
                <p className={s.noValues} key="no-values">
                    No parameter values exist that match search query.
                </p>
            );
        }
    }

    handleClick = selectedEntryIndex => e => {
        this.props.onChange(this.props.data.entries[selectedEntryIndex]);
    };
}

RequestFormAutocompleteList.propTypes = propTypes;

export default connect(mapStateToProps)(RequestFormAutocompleteList);



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportPage/Form/Autocomplete/List/index.jsx